var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import SectionMessage from "@atlaskit/section-message";
import { Spinner, useMutation, Button, } from "@atlassiansox/microscopekit";
import * as Sentry from "@sentry/react";
import React, { useState } from "react";
import createLoggingServiceMutation from "../../graphql/createLoggingService.mutation.graphql";
import updateServiceMutation from "../../graphql/updateService.mutation.graphql";
import { normalise, substituteWhitespace } from "../../utils/validate";
var CreateLuigiPrompt = function (_a) {
    var serviceName = _a.serviceName, platform = _a.platform, businessUnit = _a.businessUnit, owner = _a.owner, admins = _a.admins, setHasLoggingID = _a.setHasLoggingID, showFlag = _a.showFlag;
    var _b = useState(false), creating = _b[0], setCreating = _b[1];
    var createLuigiEntry = useMutation(createLoggingServiceMutation)[0];
    var updateServiceHook = useMutation(updateServiceMutation)[0];
    var createLuigiEntryHelper = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, loggingID, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!platform || !businessUnit) {
                        showFlag({
                            type: "error",
                            title: "Invalid metadata",
                            message: "Platform and Business Unit can't be empty",
                        });
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, createLuigiEntry({
                            variables: {
                                service: {
                                    source_id: normalise(platform, 64),
                                    name: normalise(serviceName, 64),
                                    organization: substituteWhitespace(businessUnit),
                                    owner: substituteWhitespace(owner),
                                    capacity_gigabytes: 1,
                                    capacity_comment: "Preset default",
                                    acls: [
                                        {
                                            staffid_group: "atlassian-staff",
                                            environments: "*",
                                        },
                                    ],
                                    // Luigi splits this on "," when calculating groups for a service for permission checking
                                    admins: admins ? admins.join(",") : "",
                                },
                            },
                        })];
                case 2:
                    res = _c.sent();
                    loggingID = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.createLoggingService) === null || _b === void 0 ? void 0 : _b.logging_id;
                    if (!loggingID) {
                        showFlag({
                            type: "error",
                            title: "Error creating Logging ID",
                            message: "Logging ID is empty",
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, updateServiceHook({
                            variables: {
                                input: {
                                    id: serviceName,
                                    metadata: {
                                        loggingID: loggingID,
                                    },
                                },
                            },
                        })];
                case 3:
                    _c.sent();
                    setHasLoggingID(loggingID);
                    Sentry.captureMessage("Create Luigi entry success");
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _c.sent();
                    Sentry.captureException(error_1);
                    showFlag({
                        type: "error",
                        title: "Error creating Logging ID",
                        message: error_1.toString(),
                    });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Sentry.captureMessage("Create Luigi button clicked");
                    setCreating(true);
                    return [4 /*yield*/, createLuigiEntryHelper()];
                case 1:
                    _a.sent();
                    setCreating(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        platform === "micros" ? (React.createElement(SectionMessage, { appearance: "warning", title: "No Logging ID found" },
            React.createElement("p", null,
                "Your service, ",
                React.createElement("code", null, serviceName),
                " does not have a Logging ID."),
            React.createElement("p", { style: { fontWeight: "bold" } }, "Deploy your service to create one."))) : (React.createElement(SectionMessage, { appearance: "warning", title: "No Logging ID found" },
            React.createElement("p", null,
                "Your service, ",
                React.createElement("code", null, serviceName),
                " does not have a Logging ID."),
            React.createElement("br", null),
            React.createElement(Button, { appearance: "primary", onClick: handleClick, iconBefore: creating ? React.createElement(Spinner, { size: "small" }) : React.createElement(React.Fragment, null) }, "Create Logging ID"))),
        React.createElement("br", null),
        React.createElement(SectionMessage, { appearance: "information", title: "What is a Logging ID?" },
            React.createElement("p", null, "A Logging ID is an ID that is unique to your service and is required in order for your service's logs be routed correctly."),
            React.createElement("h4", null, "How do I know if I need a Logging ID?"),
            React.createElement("p", null, "If you would like to capture and view logs for your service then you need one."),
            React.createElement("p", null,
                "For ",
                React.createElement("strong", null, "non-Micros"),
                " services, you may associate a Logging ID with your service by clicking the \"Create Logging ID\" button above. More information on how to capture your non-Micros services logs can be found in the",
                " ",
                React.createElement("a", { href: "https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/140624694/Logging+pipeline+-+Sending+logs+to+Splunk" }, "documentation"),
                "."),
            React.createElement("p", null,
                "For ",
                React.createElement("strong", null, "Micros"),
                " services, a Logging ID will automatically be created for your service when it is first deployed. So you do not need to manually create a Logging ID."),
            React.createElement("h4", null, "Need Support?"),
            React.createElement("p", null,
                "You can contact us in our slack channel -",
                " ",
                React.createElement("a", { href: "https://atlassian.slack.com/archives/CFGR23610" }, "#observability")))));
};
export default CreateLuigiPrompt;
